import React from "react";
import {
  PageHeader,
  SectionCard,
} from "../components/Common";
import "./VMLogsPage.css";

const VMLogsPage: React.FC = () => {
  return (
    <div>
      <PageHeader
        title="VM Logs"
        subtitle="VM log monitoring endpoint is not available yet"
      />

      <SectionCard title="Logs API Status">
        <div className="vm-logs-page__status-card">
          <div className="vm-logs-page__status-copy">
            VM Logs endpoint has not been implemented in the backend.
          </div>

          <div>
            Required endpoint:
          </div>

          <pre className="vm-logs-page__endpoint">{`GET /monitor/vm/logs/`}</pre>

          <div style={{ marginTop: 16 }}>
            Once the backend API is available, this page can display:
          </div>

          <ul className="vm-logs-page__list">
            <li>System logs</li>
            <li>Journalctl logs</li>
            <li>Docker daemon logs</li>
            <li>Real-time streaming logs</li>
            <li>Log filtering and search</li>
          </ul>
        </div>
      </SectionCard>
    </div>
  );
};

export default VMLogsPage;